import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const editProductApi = (data) =>
    Promise.resolve(axios.post(endpoints.editProduct, data));
